const HaveFunFriendInitialText ="What do you think about inviting a friend to join you? " +
    "Doing something fun with a friend can make the activity even more enjoyable. " +
    "Do you want to invite a friend to join you?"
        
export default HaveFunFriendInitialText 
 